import { Organization } from '@iot-platform/models/common';
import { createAction, props } from '@ngrx/store';

export const addOrganization = createAction('[Organizations/Admin Page] ADD Organization', props<{ newOrganization: Organization }>());
export const updateOrganization = createAction('[Organizations/Admin Page] UPDATE Organization', props<{ organizationToUpdate: Organization }>());
export const deleteOrganization = createAction('[Organizations/Admin Page] DELETE Organization', props<{ organizationToDelete: Organization }>());
export const selectOrganization = createAction('[Organization/Admin Page] SELECT Organization', props<{ selectedOrganizationId: string }>());

export const listOrganizations = createAction('[Organizations/Admin Page] List ALL Organizations');
